import React from "react";
import { useSelector } from "react-redux";
import styles from "../MainHeader.module.scss";
import { SettingsIcon } from "@netapp/bxp-style/react-icons/Action";
import { HeaderSettingsIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import SlidingWidget from "./SlidingWidget";
import MenuLinkItem from "./MenuLinkItem";
import _ from "lodash";
import { isNewTenancyEnabled } from "utils/localstorage";
import { hasAccessPermission } from "utils/permissions";
import { useTranslation } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../../i18n/namespace";

const Content = React.memo(() => {
    const activeAgent = useSelector(state => state.tenancy.selectedAgent);
    const noConnector = process.env.REACT_APP_IS_SAAS === "true" && !activeAgent;
    const darkSite = process.env.REACT_APP_IS_DARK === 'true';
    const installLocation = useSelector(state => state.app.instancePlacement?.installLocation?.toLowerCase());
    // Get the Feature flag state from Redux state.
    const isTenancyV4 = isNewTenancyEnabled();
    const { forbidden, permissions, selectedScope } = useSelector(state => state.tenancy);
    const { t } = useTranslation(i18nNamespace);

    const hasPermissions = (permissionKey) => {
        if (!isTenancyV4 && !permissions.allTabsAvailable) {
            return false
        }
        if (isTenancyV4 && (permissionKey && !hasAccessPermission(selectedScope.rules, [permissionKey]))) {
            return false
        }
        return true
    }

    return <div className={styles['menu-content']}>
        {/* If Tenancy V4 enabled from feature flag, then show this Menu Item in settings page. */}
        {isTenancyV4 && permissions.editAccount && !darkSite && <MenuLinkItem to="/identity-access-mgmt/organization">{t("identity_and_access_management")}</MenuLinkItem>}
        {hasPermissions("cvo_settings") && <MenuLinkItem disabled={noConnector} to="/connector-settings/settings">{t("cloud_volumes_ontap_settings")}</MenuLinkItem>}
        {hasPermissions("timeline") && <MenuLinkItem to="/timeline">{t("timeline")}</MenuLinkItem>}
        {hasPermissions("credentials") && <MenuLinkItem disabled={darkSite && installLocation === "onprem"} to="/credentials/account-credentials">{t("credentials")}</MenuLinkItem>}
        {hasPermissions("https_setup") && <MenuLinkItem disabled={noConnector} to="/connector-settings/certificate-setup">{t("https_setup")}</MenuLinkItem>}
        {hasPermissions("notifications") && !darkSite && <MenuLinkItem to="/alerts-and-notifications/users">{t("alerts_and_notifications_settings")}</MenuLinkItem>}
    </div>;
});

export default () => {
    const { forbidden, permissions } = useSelector(state => state.tenancy);
    const disabled = (process.env.REACT_APP_IS_SAAS !== "true" && forbidden) || (!permissions.allTabsAvailable && !permissions.editAccount);
    const { t } = useTranslation(i18nNamespace);

    return <SlidingWidget
        widgetKey="settings"
        menuTitle={t("settings")}
        MenuIcon={SettingsIcon}
        triggerClassName={styles['widget-button']}
        triggerActiveClassName={[styles['widget-button-active']]}
        triggerChildren={<HeaderSettingsIcon size={24} display="block"/>}
        triggerDisabled={disabled}
    >
        <Content/>
    </SlidingWidget>;
};
